import { ICourse } from '@sdk/contracts';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import { Icon } from '@/components/Icon';
import { useActivityForm } from '@/store';

type Props = {
  sectionId: string;
  course: ICourse;
};

export const NewActivity: React.FC<Props> = ({ sectionId, course }) => {
  const { t } = useTranslation('CourseTranslations');
  const { setIsOpen, setSectionId, setCourse } = useActivityForm();

  const onClick = () => {
    setCourse(course);
    setSectionId(sectionId);
    setIsOpen(true);
  };

  return (
    <Button type="default" onClick={onClick} icon={<Icon i="Add" />}>
      {t('CREATE_ACTIVITY')}
    </Button>
  );
};
